import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { updatePackageReq } from '../packageReqService'
import { GetPkgReqsListResponse } from '../types/GetPkgReqsListResponse'

export const useUpdatePackageReq = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updatePackageReq,
    onSuccess: (res, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
      if (res?.packageId) {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS_FEES, res.packageId] })
      }
      res?.unitePackageIds?.forEach(id => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS_FEES, id] })
      })

      // Patch the (heavy) paginated list cache in place instead of refetching it.
      // We keep the existing joined `pkgs` and overlay the server's updated row.
      if (res) {
        queryClient.setQueriesData<GetPkgReqsListResponse>({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS, 'list'] }, old => {
          if (!old?.items) return old
          return {
            ...old,
            items: old.items.map(item => (item.id === res.id ? { ...item, ...res, pkgs: item.pkgs } : item)),
          }
        })
      }

      // Counts only shift when a return label re-opens a request to pending; a
      // fee edit never moves an item between buckets, so skip the refetch then.
      if (variables.returnLabel) {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS, 'counts'] })
      }
    },
  })
}
